export default {
      id: "icon-delete-usage",
      viewBox: "-5 -3 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-delete",
      toString: function () {
        return this.url;
      }
    }